import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { GlobalStore } from 'app/store/global.store';
import { filter, map, take, tap } from 'rxjs';

export const featureFlagGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const globalStore = inject(GlobalStore);
  const router = inject(Router);
  const flagName = route.data['featureFlag'] as string;

  return toObservable(globalStore.config).pipe(
    filter((config) => config !== null),
    take(1),
    map((config) => !!config[flagName]),
    tap((isAllowed) => {
      if (!isAllowed) {
        router.navigate(['/not-found']).then(() => {});
      }
    })
  );
};
